import * as stylex from '@stylexjs/stylex';
import clsx from 'clsx';
import _ from 'lodash';
import { HoverTooltip } from '@/core/HoverTooltip.atom';
import type { StyleXStyles } from '@stylexjs/stylex';
import type { TooltipPosition } from '@seeqdev/qomponents';

/**
 * This component renders a "Link" that doesn't have an actual href value. React-Router doesn't like links like <a
 * href='#" ... so instead we can use this component to render a "look a like"
 **/
export interface FakeLinkIF {
  onClick?: (e?: any) => any;
  id?: string;
  testId?: string;
  children?: React.ReactNode;
  extraClassNames?: string;
  xstyle?: StyleXStyles;
  target?: string;
  destination?: string;
  tooltipText?: string;
  tooltipPlacement?: TooltipPosition;
}

export const FakeLink = ({
  testId,
  onClick = _.noop,
  id,
  children,
  extraClassNames,
  xstyle,
  target,
  destination,
  tooltipText,
  tooltipPlacement = 'top',
}: FakeLinkIF) => {
  // this is needed for one special case :(
  const openWindow = () => {
    window.open(destination, '_blank');
  };

  // Either styling API replaces the legacy default, preserving existing custom-link appearance.
  const styleProps = stylex.props(xstyle);

  return (
    <HoverTooltip text={tooltipText} placement={tooltipPlacement}>
      <span
        {...styleProps}
        onClick={target ? openWindow : onClick}
        className={clsx(
          'link',
          'cursorPointer',
          extraClassNames || xstyle ? extraClassNames : 'fakeLink',
          styleProps.className,
        )}
        id={id}
        data-testid={testId}>
        {children}
      </span>
    </HoverTooltip>
  );
};
